export const extracurriculars = {
  title: "Actividades Extraescolares",
  metaDescription: "Actividades extraescolares en Gándara International School - Inglés, Música, Circo, Imaxina y más",
  weeklySchedule: {
    title: "Horario Semanal",
    filterLabels: {
      english: "Inglés",
      xogos: "Xogos",
      music: "Música", 
      circus: "Circo",
      search: "Buscar actividad… (p. ej. English)"
    },
    schedule: [
      {
        day: "Lunes",
        subtitle: "English Starters e Imaxina",
        sessions: [
          {
            title: "English Starters Grupo 1",
            time: "15:30 a 16:30",
            instructor: "Patri",
            badge: "3-5 años",
            tags: ["english"]
          },
          {
            title: "English Starters Grupo 2", 
            time: "16:30 a 17:30",
            instructor: "Patri",
            badge: "3-5 años",
            tags: ["english"]
          },
          {
            title: "Imaxina",
            time: "16:30 a 18:30",
            instructor: "Xavi",
            badge: "8–12 años",
            tags: ["imaxina", "creatividad"]
          }
        ]
      },
      {
        day: "Martes",
        subtitle: "English Advance",
        sessions: [
          {
            title: "English Advance Grupo 1",
            time: "15:30 a 16:30",
            instructor: "Sandra",
            badge: "6–12 años",
            tags: ["english"]
          },
          {
            title: "English Advance Grupo 2",
            time: "16:30 a 17:30", 
            instructor: "Sandra",
            badge: "6–12 años",
            tags: ["english"]
          }
        ]
      },
      {
        day: "Miércoles",
        subtitle: "Xogos de Mesa (8-12 años)",
        sessions: [
          {
            title: "Xogos de Mesa",
            time: "16:30 a 18:30",
            instructor: "Xavi",
            badge: "8–12 años",
            tags: ["xogos"]
          }
        ]
      },
      {
        day: "Jueves",
        subtitle: "Taller de Música y Circo",
        sessions: [
      {
        title: "LET'S PLAY GUITAR",
        time: "15:30 a 16:30",
        instructor: "Óscar",
        badge: "8–12 años",
        tags: ["music"]
      },
      {
        title: "ENJOY THE MUSIC",
        time: "16:30 a 17:30",
        instructor: "Óscar",
        badge: "5-8 años",
        tags: ["music"]
      },
          {
            title: "Circo",
            time: "17:30 a 18:30",
            instructor: "",
            badge: "8–12 años",
            tags: ["circus"]
          }
        ]
      }
    ]
  },
  ludoteca: {
    title: "Servicio de Ludoteca",
    schedule: "Horario de ludoteca: 15:30 a 18:30",
    freeService: "Gratis siempre que se tome comedor u otra actividad extraescolar",
    pricing: {
      title: "Precios ludoteca sin comedor ni extraescolares:",
      dayPass: "Día suelto: 8€/día",
      oneDay: "Un día a la semana: 25€/mes",
      twoDays: "Dos días a la semana: 40€/mes",
      fiveDays: "Cinco días a la semana: 100€/mes"
    }
  },
  activities: {
    title: "Actividades Extraescolares - Precios",
    list: [
      {
        name: "Imaxina",
        age: "8-12 años",
        price: "40 €/mes",
        description: "Acompañamiento y aprendizaje a través de juego de rol"
      },
      {
        name: "Juegos de Mesa",
        age: "8-12 años", 
        price: "40 €/mes",
        description: "Acompañamiento a través de juegos de mesa"
      },
      {
        name: "Inglés Lúdico-vivencial",
        age: "3-12 años",
        price: "40 €/mes",
        description: "A través de juegos, música, artes..."
      },
      {
        name: "Circo en inglés",
        age: "6-12 años",
        price: "35 €/mes",
        description: "Aprendizaje de técnicas de circo en inglés"
      },
      {
        name: "ENJOY THE MUSIC",
        age: "5-8 años",
        price: "40 €/mes",
        description: "Iniciación musical para los más pequeños"
      },
      {
        name: "LET'S PLAY GUITAR",
        age: "8-12 años", 
        price: "40 €/mes",
        description: "Aprendizaje de guitarra para niños"
      }
    ]
  },
  contact: {
    info: "Más información e inscripciones",
    description: "Para más información y/o apuntarse:",
    email: "info@gandaraschool.com"
  }
};